/*
 * The primitives are EXPORTED so a page with a different stack can build its own
 * skeleton out of the same bars instead of eyeballing a second set — see
 * PhoneBookingSkeleton, which reuses everything below and adds the blocks that page
 * has on top of this one's.
 */
export const S = ({w = '100%', h = 16, r = 8, mb = 0, className = ''}) => (
    <div className={`animate-pulse bg-gray-200 shrink-0 ${className}`}
         style={{width: w, height: h, borderRadius: r, marginBottom: mb}}/>
)

export const WhiteCard = ({children}) => (
    <div className="bg-white p-5 rounded-(--radius-2xl)">{children}</div>
)

// Outer title + bordered box (matches RouteCard: From Airport / Drop off Address)
export const RouteSkeleton = () => (
    <div>
        <S w="35%" h={22} mb={12}/>
        <div className="bg-white px-4 py-3 rounded-(--radius-xl) border border-(--text-primary) min-h-[88px] flex items-center gap-5">
            <S w="60%" h={16}/>
            <S w={18} h={18} r={4} className="ml-auto"/>
        </div>
    </div>
)

// Bordered collapsible card (matches Passengers / Child Seats / Luggage / Oversized)
export const SummarySkeleton = () => (
    <div className="bg-white px-4 py-3 rounded-(--radius-xl) border border-(--text-primary) min-h-[88px] flex items-center gap-5">
        <S w={36} h={36} r={8}/>
        <div className="flex-1">
            <S w="40%" h={20} mb={8}/>
            <S w="65%" h={14}/>
        </div>
        <S w={18} h={18} r={4}/>
    </div>
)

export default function SkeletonCards() {
    return (
        <>
            {/* Header */}
            <div className="max-w-3xl mx-auto text-center mb-5">
                <S w="35%" h={30} className="mx-auto"/>
            </div>

            {/* Perks bar + popular questions */}
            <div className="max-w-3xl mx-auto mb-5 flex flex-col gap-7">
                <S w="100%" h={56} r={20}/>
                <S w="100%" h={120} r={16}/>
            </div>

            {/* Main grey container */}
            <div className="max-w-3xl mx-auto flex flex-col gap-4 p-5 pb-8 bg-(--bg-grey) rounded-(--radius-2xl) max-md:p-0 max-md:bg-transparent">
                <RouteSkeleton/>
                <RouteSkeleton/>

                {/* Date & Time */}
                <WhiteCard>
                    <S w="40%" h={18} mb={14}/>
                    <div className="flex gap-3">
                        <S w="50%" h={44} r={10}/>
                        <S w="50%" h={44} r={10}/>
                    </div>
                </WhiteCard>

                {/* Passengers / Child Seats / Luggage / Oversized */}
                <SummarySkeleton/>
                <SummarySkeleton/>
                <SummarySkeleton/>
                <SummarySkeleton/>

                {/* Special Request + Vehicle Detail */}
                <div className="flex gap-4 items-stretch max-md:flex-col">
                    <WhiteCard>
                        <S w="70%" h={14} mb={10}/>
                        <S w="60%" h={14} mb={10}/>
                        <S w="50%" h={14} mb={16}/>
                        <S w="100%" h={90} r={16}/>
                    </WhiteCard>
                    <WhiteCard>
                        <div className="flex items-center gap-3 mb-5">
                            <S w={48} h={48} r={8}/>
                            <S w="50%" h={18}/>
                        </div>
                        <S w="100%" h={14} mb={10}/>
                        <S w="100%" h={14} mb={10}/>
                        <S w="100%" h={14} mb={16}/>
                        <S w={40} h={40} r={9999} className="ml-auto"/>
                    </WhiteCard>
                </div>

                {/* Payment Methods */}
                <WhiteCard>
                    <S w="40%" h={18} mb={16}/>
                    <S w="100%" h={56} r={16} mb={12}/>
                    <S w="100%" h={56} r={16}/>
                </WhiteCard>

                {/* Continue button */}
                <S w="100%" h={55} r={9999}/>

                {/* Terms text */}
                <S w="70%" h={12} className="mx-auto"/>
            </div>
        </>
    )
}
